import { gql } from '@apollo/client';

export default gql`
  mutation addPreferencesKeyword($input: String!) {
    addBuyerPreferencesKeyword(input: $input)
  }
`;
